<template>
  <v-list-item v-if="checkRightStatus(15)" @click="deleteDonor(donor)">
    <v-list-item-title>{{ $t("buttons.delete") }}</v-list-item-title>
  </v-list-item>
</template>

<script>
import { mapGetters } from "vuex";
import donorService from "@/modules/Donors/service.js";

export default {
  props: ["donor"],
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
  },
  methods: {
    deleteDonor() {
      if (!this.checkRightStatus(39)) {
        this.$swal(
          "Delete Customer",
          "You are not allow to delete customer with balance.",
          "warning"
        );
        return false;
      }
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          donorService
            .delete(this.donor.id)
            .then((response) => {
              if (response.data) {
                this.$swal("Deleted!", "donor has been deleted.", "success");
                this.$emit("submit");
              }
            })
            .catch((error) => {
              throw error;
            });
        }
      });
    },
  },
};
</script>

<style scoped></style>
